export default {"src":"/sitetest/_next/static/media/toRegist.93fa6b1e.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};